export function validClosingDate(value) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !value.startsWith('0000-') &&
    Number.isFinite(Date.parse(value + 'T00:00:00Z')) && new Date(value + 'T00:00:00Z').toISOString().slice(0,10) === value;
}
const numeric = value => (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) && Number.isFinite(Number(value));
export function validClosingResponse(body) {
  return !!body && ['A','B','C','D'].every(key => Array.isArray(body[key]) && numeric(body['total'+key]) &&
    body[key].every(row => row && typeof row === 'object' && numeric(row.valor) &&
      Number.isSafeInteger(Number(row.registro_id)) && Number(row.registro_id) > 0 &&
      ['descricao','forma_pagamento','refil'].every(field => Object.hasOwn(row,field) && (row[field] === null || typeof row[field] === 'string')) &&
      Object.entries(row).every(([field,value]) => (!field.startsWith('data_') && field !== 'recebimento_previsto') || value == null || value === '' ||
        (typeof value === 'string' && validClosingDate(value.split('T')[0])))));
}
export function closingError(error) {
  const status = error.response?.status;
  if (status === 403) return 'Você não possui permissão para emitir o Fechamento Diário.';
  if (status === 400) return 'Informe uma data válida para consultar o Fechamento Diário.';
  if (status === 401) return 'Sua sessão expirou. Entre novamente para emitir o relatório.';
  return 'Não foi possível carregar um Fechamento Diário válido. Tente novamente.';
}
